import styled from 'styled-components'

export const Slider = styled.div`
    input[type='range'] {
        -webkit-appearance: none;
        width: 100%;
        height: 5px;
        border-radius: 5px;
        background: #444;
        outline: none;
        padding: 0;
        margin: 0;
    }
    input[type='range']::-webkit-slider-thumb {
        -webkit-appearance: none;
        appearance: none;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: ${props => props.theme.admin.editor.text};
        cursor: pointer;
        transition: background 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    input[type='range']::-webkit-slider-thumb:hover {
        background: ${props => props.theme.admin.colors.brand};
    }
    input[type='range']:active::-webkit-slider-thumb {
        background: ${props => props.theme.admin.colors.brand};
    }
    input[type='range']::-moz-range-thumb {
        width: 14px;
        height: 14px;
        border: 0;
        border-radius: 50%;
        background: ${props => props.theme.admin.editor.text};
        cursor: pointer;
        transition: background 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    input[type='range']::-moz-range-thumb:hover {
        background: ${props => props.theme.admin.colors.brand};
    }
    input[type='range']:active::-moz-range-thumb {
        background: ${props => props.theme.admin.colors.brand};
    }
    input[type='range']:focus::-webkit-slider-thumb {
        box-shadow: 0 0 0 2px #444, 0 0 0 4px ${props => props.theme.admin.colors.brand};
    }

    ::-moz-range-track {
        background: #444;
        border: 0;
    }

    input::-moz-focus-inner,
    input::-moz-focus-outer {
        border: 0;
    }
`
